import { useQuery } from '@tanstack/react-query';

import { type CustomRuleSearchParams, searchCustomRules } from '~/services/LuxLoyalty';

import { customRuleQueryKeys } from './customRuleQueryKeys';

interface UseSearchCustomRulesOptions {
  enabled?: boolean;
}

export function useSearchCustomRules(
  params: CustomRuleSearchParams,
  { enabled = true }: UseSearchCustomRulesOptions = {},
) {
  return useQuery({
    queryKey: customRuleQueryKeys.search(params),
    queryFn: ({ signal }) => searchCustomRules(params, { signal }),
    enabled,
    staleTime: 30_000,
  });
}
